import styled from "styled-components";

const bp = { md: "768px" };

const c = {
  black: "#141414",
  white: "#ffffff",
  ink: "rgba(0,0,0,0.90)",
  inkSoft: "rgba(0,0,0,0.62)",
  gold: "#c9a227",
  goldLine: "rgba(201,162,39,0.45)",
};

export const Container = styled.div`
  min-height: calc(100vh + 60px);
  background: transparent;
  color: ${c.ink};

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 52px 14px 100px;

  * {
    box-sizing: border-box;
  }

  @media (max-width: ${bp.md}) {
    padding: 28px 14px 90px;
  }
`;

export const Header = styled.div`
  text-align: center;
`;

export const Title = styled.h1`
  margin: 6px 0 10px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.92);

  @media (max-width: ${bp.md}) {
    font-size: 26px;
  }
`;

export const Ornament = styled.div`
  position: relative;
  width: 260px;
  height: 14px;
  margin: 6px auto 14px;
`;

export const OrnLine = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: rgba(201, 162, 39, 0.42);
  border-radius: 999px;
`;

export const OrnDiamond = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%) rotate(45deg);
  background: #c9a227;
  border-radius: 2px;

  box-shadow:
    0 0 0 3px rgba(201, 162, 39, 0.14),
    0 1px 2px rgba(0, 0, 0, 0.12);
`;

export const Form = styled.form`
  margin-top: 22px;
  width: 94%;
  max-width: 600px;

  background: #ffffff;
  border-radius: 22px;

  border: 1px solid rgba(201, 162, 39, 0.5);
  box-shadow:
    0 0 0 5px rgba(201, 162, 39, 0.05),
    0 24px 64px rgba(0, 0, 0, 0.1);

  padding: 36px 40px 30px;

  display: flex;
  flex-direction: column;
  gap: 16px;

  font-family: "Cormorant Garamond", serif;
  font-size: 16px;
  line-height: 1.35;

  @media (max-width: 1024px) {
    max-width: 660px;
    padding: 32px 30px;
  }

  @media (max-width: 768px) {
    max-width: 94%;
    padding: 26px 18px 22px;
    font-size: 15px;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 15px;
  font-weight: 700;
  font-family: "Cormorant Garamond", serif;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.72);

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const Input = styled.input`
  display: block;
  width: 100%;

  background: #ffffff;
  color: ${c.ink};

  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 14px;
  padding: 12px 14px;

  font-size: 16px;
  outline: none;

  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus {
    border-color: rgba(201, 162, 39, 0.85);
    box-shadow: 0 0 0 3px rgba(201, 162, 39, 0.12);
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  font-size: 15px;
  color: ${c.ink};
  background: #ffffff;
  outline: none;

  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:focus {
    border-color: rgba(201, 162, 39, 0.85);
    box-shadow: 0 0 0 3px rgba(201, 162, 39, 0.12);
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 6px 0 4px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;

  font-family: "Cormorant Garamond", serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.78);
  line-height: 1.55;

  span {
    display: inline;
  }

  button {
    color: #ff77b4;
    font-weight: 700;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
    font-family: inherit;
    font-size: inherit;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const Checkbox = styled.input`
  margin-top: 6px;
  accent-color: ${c.gold};
`;

export const CheckboxError = styled.div`
  font-size: 12px;
  color: rgba(140, 0, 0, 0.92);
  margin-top: -6px;
  margin-left: 28px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  margin-top: 8px;

  background: ${c.black};
  color: rgba(255, 255, 255, 0.94);

  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;

  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(201, 162, 39, 0.34);
  cursor: pointer;

  font-size: 16px;

  transition:
    transform 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(201, 162, 39, 0.55);
    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.12);
  }

  &:active {
    transform: translateY(0px);
    box-shadow: none;
  }
`;

export const Note = styled.p`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.56);
  font-weight: 600;
  margin: 6px 0 0;
`;
